<template>
    <PopupRouterViewDetail label="Delivery Status Detail" @hideMethod="onHidden" :isShowCopyData="false">

        <!-- APP_DETAIL_HEADER -->

        <b-card header="Delivery Status" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-code" label-cols-lg="12"  label="Code" label-for="input-code" size="sm" :model.sync="model.code" :isRequired="true" :state="validateState('code')" :errorMessage="getErrorMessage(errorMessage.code, 'code')"  @change="updateData"  :isUpdatable="true" :isEditable="false" />
						<app-input-textbox id="fieldset-name" label-cols-lg="12"  label="Name" label-for="input-name" size="sm" :model.sync="model.name" :isRequired="true" :state="validateState('name')" :errorMessage="getErrorMessage(errorMessage.name, 'name')"  @change="updateData"  :isUpdatable="true" :isEditable="false" />
					</b-col>
					<b-col cols="12" lg="6">
				</b-col>

            </b-row>
        </b-card>

        <!-- END_APP_DETAIL_HEADER -->

        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterViewDetail>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import DeliveryStatus from '@/models/DeliveryStatus/DeliveryStatus';
import DeliveryStatusList from '@/models/DeliveryStatus/DeliveryStatusList';
import DeliveryStatusFilter from '@/filters/DeliveryStatus/DeliveryStatusFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';

import AppInputTextbox from '@/components/AppInputTextbox';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputTextbox,
		PopupRouterViewDetail,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			code: {required},
			name: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				code: { required : "Code is Required."},
				name: { required : "Name is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterDeliveryStatus : null,
			currentDeliveryStatusPage : 1,
			deliveryStatusPageSize: 10,
			sortByDeliveryStatus: '',
			sortDescDeliveryStatus: '',
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
		}
	},
	methods : {
		getDeliveryStatus : async function(id) {
			this.isBusy = true;
			DeliveryStatus.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadDeliveryStatus = true;
			this.filterDeliveryStatus.id = this.modelId;
			DeliveryStatus.downloadDataDetail(this, this.filterDeliveryStatus).then(result => {
				this.isDownloadDeliveryStatus = false;
			}).catch(error => { this.isDownloadDeliveryStatus = false; })
		},
		getDeliveryStatuss : async function(input) {
			let filter = new DeliveryStatusFilter();
			if (input != undefined) {
				filter.Name = input;
			}
			this.isDeliveryStatusComboLoading = true;
			DeliveryStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.deliveryStatuss = result.data
				}
				this.isDeliveryStatusComboLoading = false;
			})
			.catch(error => {});
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.deliveryStatusInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				let promises = Array();

				Promise.all(promises).then((results) => {
					if (id != '' && id != null && id != undefined) {
						DeliveryStatus.updateData(this, model, id).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'deliverystatusindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						DeliveryStatus.insertData(this, model).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'deliverystatusindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					}
				});
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					DeliveryStatus.updateDataDetail(this, model, id)
					.catch((error) => {
						this.getDeliveryStatus(id);
					});
				}
			});
		},
		onHidden() {
			this.getDeliveryStatuss();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterDeliveryStatus = new DeliveryStatusFilter();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getDeliveryStatus(id);
			} else {
				this.modelId = id;
				this.getDeliveryStatus(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				if(this.model.mainRecordId != undefined || this.model.mainRecordId != null) return false;
				return true;
			}
		}
	},
	watch : {
	},
}
</script>
